var BASE_PATH_MAP = {
  fr: '/modeles',
  es: '/plantillas',
  pt: '/modelos',
  it: '/modelli'
};
export var getBasePath = function getBasePath(locale) {
  return BASE_PATH_MAP[locale] || '/templates';
};